import { CalendarPlus } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "../ui/dropdown-menu";
import { API } from "../../lib/api";

const stamp = (d) => d.toISOString().slice(0, 19).replace(/[-:]/g, "");

const googleUrl = (s) => {
  const start = new Date(`${s.date}T${s.time || "20:00"}:00Z`);
  const end = new Date(start.getTime() + 3 * 3600 * 1000);
  const page = `${window.location.origin}/shows/${s.id}`;
  const q = new URLSearchParams({
    action: "TEMPLATE",
    text: s.title,
    dates: `${stamp(start)}/${stamp(end)}`,
    location: `${s.venue}, ${s.city}`,
    details: `Doors ${s.time}. Tickets: ${page}`,
  });
  return `https://calendar.google.com/calendar/render?${q}`;
};

// show: { id, title, date, time, venue, city }
export const AddToCalendar = ({ show, testid = "add-to-calendar", compact = false }) => (
  <DropdownMenu>
    <DropdownMenuTrigger asChild>
      <button data-testid={`${testid}-button`}
        className={`btn-line rounded-full font-cond uppercase font-bold tracking-widest inline-flex items-center gap-2 ${compact ? "px-4 py-2 text-sm" : "px-6 py-3"}`}>
        <CalendarPlus className="w-4 h-4" /> Add to calendar
      </button>
    </DropdownMenuTrigger>
    <DropdownMenuContent className="bg-[#12141a] border-[#222634] text-slate-100">
      <DropdownMenuItem asChild>
        <a href={`${API}/share/shows/${show.id}.ics`} data-testid={`${testid}-ics`} className="cursor-pointer">Apple / phone calendar</a>
      </DropdownMenuItem>
      <DropdownMenuItem asChild>
        <a href={googleUrl(show)} target="_blank" rel="noopener noreferrer" data-testid={`${testid}-google`} className="cursor-pointer">Google Calendar</a>
      </DropdownMenuItem>
      <DropdownMenuItem asChild>
        <a href={`${API}/share/shows/${show.id}.ics`} data-testid={`${testid}-outlook`} className="cursor-pointer">Outlook (.ics file)</a>
      </DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
);
